export default __webpack_public_path__ + "static/media/AhelyS.4dc525e0.jpg";